import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "antd/dist/antd.css";

// Ignore known browser ResizeObserver noise that can appear with complex layouts
// (e.g. table/popconfirm reflow) and otherwise triggers noisy runtime overlay in dev.
if (typeof window !== "undefined") {
  const resizeObserverErrors = [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
  ];
  const isResizeObserverNoise = (value) => {
    const message =
      typeof value === "string"
        ? value
        : value?.message || value?.reason?.message || "";
    return resizeObserverErrors.some((text) => message.includes(text));
  };

  window.addEventListener("error", (event) => {
    if (isResizeObserverNoise(event?.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isResizeObserverNoise(event?.reason)) {
      event.preventDefault();
    }
  });

  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (args.some((arg) => isResizeObserverNoise(arg))) return;
    originalConsoleError(...args);
  };
}


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);
  // <React.StrictMode>
  // </React.StrictMode>

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

